<template>
  <section>
    <div class="columns mb-0">
      <div class="column is-6 is-offset-3">
        <socialLogin
          :from="from"
          :params="$route.params"
          :divider="!socialRegistration"
          @registration="setSocialRegistration"
        />
        <login
          v-if="!socialRegistration"
          :from="from"
          :params="$route.params"
        />
      </div>
    </div>
  </section>
</template>
<script>
import login from '~/components/login'
import socialLogin from '~/components/social-login'

export default {
  components: {
    login,
    socialLogin
  },
  data: () => ({
    title: 'Log In',
    from: null,
    socialRegistration: false
  }),

  // expose data to head of website
  // @note: error function returns 'undefined'!
  head() {
    return {
      title: this.title
    }
  },

  methods: {
    setSocialRegistration(value) {
      this.socialRegistration = value
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.from = from
    next()
  }
}
</script>
